<template>
  <b-modal
    v-if="modalId"
    :id="modalId"
    title="Review Account Share Invitation"
    ok-title="Accept"
    ok-variant="success"
    cancel-title="Decline"
    cancel-variant="danger"
    no-close-on-backdrop
    :busy="isProcessing"
    @ok="handleSubmit"
    @cancel="handleSubmit"
    @hidden="$emit('hidden')"
  >
    <b-overlay :show="isProcessing">
      {{ notification.notification.creator.name }} wants to share '{{ notification.notification.share.description }}' account with you.

      <div class="d-flex pt-2 pb-1 ml-1 mb-1">
        <b-avatar
          :size="62"
          class="mr-2"
        >
          <i
            :class="getWalletIcon(notification.notification.share.wallet.__typename)"
            class="fa-24"
          />
        </b-avatar>

        <div>
          <h4 class="mb-0">
            {{ notification.notification.share.description }}
          </h4>
          <p class="small mb-0">
            {{ notification.notification.share.wallet.__typename === 'BANKWALLET' ? 'Bank Account' : 'Alt Account' }}
          </p>
          <small>Rights: {{ getShareDirection(notification.notification.invitation.shareDirection) }}</small>
        </div>
      </div>

      <!-- Wallet Share Alias -->
      <validation-observer ref="walletShareAliasForm">
        <validation-provider
          #default="{ errors }"
          name="alias"
          rules="required"
        >
          <b-form-group
            label="Alias for Shared Account"
          >
            <b-form-input
              v-model="description"
              type="text"
              placeholder="Alias"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </b-form-group>
        </validation-provider>
      </validation-observer>
    </b-overlay>
  </b-modal>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import {
  BModal, BOverlay, BFormGroup, BFormInput, BAvatar,
} from 'bootstrap-vue'
import useApollo from '@/plugins/graphql/useApollo'
import EventBus from '@/event-bus'
import useWallet from '@/utils/wallet'

const { getWalletIcon } = useWallet()

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    BModal,
    BOverlay,
    BFormGroup,
    BFormInput,
    BAvatar,
  },
  props: {
    notification: {
      type: Object,
      required: true,
    },
    modalId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      description: '',
      isProcessing: false,
      getWalletIcon,
    }
  },
  watch: {
    notification: {
      handler() {
        this.$nextTick(() => {
          this.$bvModal.show(this.modalId)
        })
      },
      immediate: true,
    },
  },
  methods: {
    getShareDirection(direction) {
      switch (direction) {
      case 'INBOUND':
        return 'In Bound'
      case 'OUTBOUND':
        return 'Out Bound'
      default:
        return 'In Bound and Out Bound'
      }
    },
    handleSubmit(bvModal) {
      bvModal.preventDefault()
      if (bvModal.trigger === 'ok') {
        this.$refs.walletShareAliasForm.validate().then(success => {
          if (success) {
            this.approveWalletShare(true)
          }
        })
      } else this.approveWalletShare(false)
    },
    approveWalletShare(approved) {
      this.isProcessing = true
      const params = {
        shareUid: this.notification.notification.share.uuid,
        input: {
          checksum: this.notification.notification.invitation.checksum,
          description: this.description,
        },
        decline: !approved,
      }

      useApollo.users.approveWalletShareInvite(params)
        .then(response => {
          this.showSuccessMessage({
            data: {
              message: response.data.approveWalletShareInvite.message,
            },
          })
          EventBus.$emit('wallet-share-approved')
        }).finally(() => {
          this.$emit('refetch')
          this.isProcessing = false
          this.$bvModal.hide(`wallet-share-invite-${this.notification.notification.invitation.checksum}-modal`)
        })
    },
  },
}
</script>

<style scoped>
  .fa-24 {
    font-size: 24px;
  }
</style>
